import axiosInstance from "../../../services/config/axiosinstance";
import { urlBaseAccreditation } from './../../config/index';

export default async function getActionsTrashApi(
  eventId = ''
) {
  try {
    const _ret = await axiosInstance({
      url: `${urlBaseAccreditation}/action/getTrashList`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        eventId: parseInt(eventId),
        apiType: 'inteegra',
      }
    });

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data.data;

  } catch (error) {
    console.log('Error getActionsTrashApi', error);
    throw error;
  }
}
